import React from 'react';
import Modal from './Modal';
import { useLanguage } from '../context/LanguageContext';

export default function ConfirmDialog({ isOpen, onClose, onConfirm, title = null, message = null }) {
  const { t } = useLanguage();

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title || t('common.confirm')}>
      <div className="confirm-body">
        <div className="confirm-icon">&#9888;</div>
        <p className="confirm-text">{message || t('common.confirmMsg')}</p>
      </div>
      <div className="modal-footer">
        <button className="btn-secondary" onClick={onClose}>{t('common.cancel')}</button>
        <button className="btn-danger" onClick={onConfirm}>{t('common.delete')}</button>
      </div>
    </Modal>
  );
}
